/*
* Usage:
*
* <button data-share>Share now!</button>
*
*/
import React, { useEffect, useRef } from 'react';
import { findMany, find, removeClass, addClass, on } from '../helpers';
import { GaEvent } from '../EventTracking';

const closeButtons = findMany('[data-share-close]');
const shareLinks = findMany('[data-share-modal] a');
const modal = find('[data-share-modal]');

const shareEvent = ({ category, action, label }) => {
    GaEvent({
        category: category || 'Sharing',
        action: action || 'Click',
        label: label || null,
    })
}

const modalError = () => {
    const msg = '_social-share-modal.twig not found on page.';

    alert(msg);
    throw new Error(msg);
}

const listenForEscape = event => {
    if (event.key === 'Escape') {
        return close();
    }
}

const open = () => {
    removeClass(modal, 'hidden');
    document.addEventListener('keydown', listenForEscape)
}

const close = () => {
    addClass(modal, 'hidden');
    document.removeEventListener('keydown', listenForEscape)
    shareEvent({ action: 'Closed Dialog', label: window.location.href });
}

closeButtons.forEach(button => {
    button.addEventListener('click', () => {
        if (!modal) {
            return modalError()
        }

        close();
    })
});

shareLinks.forEach(link => {
    const fireEvent = () => shareEvent({ action: link.innerText, label: window.location.href })

    on('click', fireEvent, link)
    on('contextmenu', fireEvent, link)
})

if (modal) {
    modal.addEventListener('click', event => {
        if (event.target === modal) {
            close();
        }
    })
}

const ShareButton = ({ text, classes }) => {
    const button = useRef()

    const listen = () => {
        button.current.addEventListener('click', async () => {

            shareEvent({ action: 'Opened Dialog', label: window.location.href });

            if (!modal) {
                return modalError()
            }

            open();
        })
    }

    useEffect(() => {
        if (button.current) {
            listen();
        }
    }, [button])

    return <button ref={ button } aria-controls={'share'} className={`flex items-center underline underline-offset-4 decoration-transparent transition ease-linear duration-300 hover:decoration-current ${classes}`}>
        <svg className="h-6 w-auto" viewBox="0 0 17 23" xmlns="http://www.w3.org/2000/svg">
            <title>{ text }</title>
            <g fill="currentColor" fillRule="nonzero">
                <path
                    d="M15.4689387 7.37372845h-2.0131408v1.34211987h1.3421199V20.7948103H1.37683592V8.71584832h1.34211987V7.37372845H.70577598c-.37092786 0-.67105994.30013207-.67105994.67105993V21.4658313c0 .3709278.30013208.6710599.67105994.6710599H15.4689387c.3709279 0 .67106-.3001321.67106-.6710599V8.04478838c0-.37092786-.3001321-.67105993-.67106-.67105993z"/>
                <path
                    d="M7.41629743 3.23207727V12.742169H8.7584173V3.23207727l2.8808081 2.88080814.9489052-.94890517L8.08735736.663207 3.58658412 5.16398024l.94890517.94890517z"/>
            </g>
        </svg>
        <span className="pl-3">{ text }</span>
    </button>
}

export default ShareButton
